import dayjs from 'dayjs';
import { omit } from 'remeda';

import { ITournamentForm } from '../../tournamentFormDialog/form';

import { TournamentModel } from 'v2/types/TournamentModel';

export function mapTournamentToForm(tournament: TournamentModel): ITournamentForm {
  const omitted = omit(tournament, ['isActive', 'id', 'isDeleted', 'isArchived']);

  return {
    ...omitted,
    groupId: tournament.groupId ?? undefined,
    endDate: dayjs(tournament.endDate),
    startDate: dayjs(tournament.startDate),
    rewards: tournament.rewards,
  };
}
